/**
 * Gets the value of the specified prop on the specified object.
 *
 * @param {object} object The object of which to get the value from.
 * @param {string} prop The name of the property whose value to get; supports 'dot'-syntax for nested props
 */
export const getPropValue = (object, prop) => {
    if (!isObject(object) || !prop) {
        return undefined;
    }
    let value = object;
    const props = prop.split('.');
    props.forEach(prop => {
        if (value && isObject(value) && value[prop] !== undefined) {
            value = value[prop];
        }
        else {
            value = undefined;
        }
    });
    return value;
};
/**
 * Checks whether the specified variable is an object.
 *
 * @param variable
 * @returns {boolean}
 */
export const isObject = (variable) => {
    return typeof variable === 'object' &&
        !Array.isArray(variable) &&
        variable !== null;
};
/**
 * Transforms the specified object into a query string for urls.
 *
 * @param object
 * @return {string}
 */
export const toQueryString = (object) => {
    let queryParts = [];
    if (object && isObject(object)) {
        Object.keys(object).forEach(key => {
            if (![null, undefined].includes(object[key])) {
                queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`);
            }
        });
    }
    return queryParts.join('&');
};
/**
 * Retrieves the value of the specified object at the prop resolved by the specified accessor.
 *
 * @param {object} object
 * @param {string|function} accessor
 * @returns {*}
 */
export const getValueOfProp = (object, accessor) => {
    if (typeof accessor === 'string') {
        const accessorParts = accessor.split('.');
        let value = object;
        accessorParts.forEach(accessorPart => {
            value = value[accessorPart];
        });
        return value;
    }
    return accessor(object);
};
/**
 * Fully recursively clones the specified object into a new object.
 *
 * @param object
 * @returns {{}}
 */
export const cloneObject = (object) => {
    if (!object) {
        return object;
    }
    if (Array.isArray(object)) {
        const clonedArray = [];
        if (object.length) {
            object.forEach((value) => {
                clonedArray.push(cloneObject(value));
            });
        }
        return clonedArray;
    }
    if (isObject(object)) {
        const clonedObject = {};
        Object.keys(object).forEach(itKey => {
            clonedObject[itKey] = cloneObject(object[itKey]);
        });
        return clonedObject;
    }
    return object;
};
//# sourceMappingURL=object-helpers.js.map